export default __webpack_public_path__ + "static/media/postgresql-logo.b941b412.svg";